
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Swal from 'sweetalert2'

import useTranslation from '@/Hooks/UseTranslation'
import { useProgrammation } from '@/Hooks/UseProgrammation'

import './RelationItem.scss'

interface Props {
  item: any
  onSelect: () => void
  readOnly?: boolean
}

const RelationItem = (props: Props) => {

  const { item, onSelect, readOnly = false } = props

  const { t } = useTranslation()

  const { itemOpened } = useProgrammation()

  const { tasks } = useSelector((state: any) => state.ProgrammationReducer)

  const [ fromTask, setFromTask ] = useState<any>()
  const [ toTask, setToTask ] = useState<any>()
  const [ type, setType ] = useState<any>()

  const relationsTypes = [
    {
      value: 'start_to_start',
      label: t('RELATIONS_CREATOR:Starts'),
    },
    {
      value: 'end_to_start',
      label: t('RELATIONS_CREATOR:Ends'),
    },
  ]

  const getRelationType = (type: string) => {

    const relationType = relationsTypes.find((t: any) => t.value === type)

    return relationType ? relationType.label : ''
  }

  useEffect(() => {

    const getTasks = () => {

      const fromTask = tasks.find((task: any) => task._id === item.from_task)
      const toTask = tasks.find((task: any) => task._id === item.to_task)

      setFromTask(fromTask)
      setToTask(toTask)
    }

    setType(item.type)

    getTasks()
  }, [ item ])

  if (!fromTask || !toTask) return null

  return (
    <div className="relation-item">
      <div className="relation-item-header">
        <div className="relation-item-name"
          onClick={onSelect}
        >
          {t('RELATIONS_CREATOR:When')}{' '}
          <strong>{fromTask.name || t('RELATIONS_CREATOR:Nameless')}</strong>{' '}
          {getRelationType(type).toLowerCase()}{' '}
          {t('RELATIONS_CREATOR:Then').toLowerCase()}{' '}
          <strong>{toTask.name || t('RELATIONS_CREATOR:Nameless')}</strong>{' '}
          {t('RELATIONS_CREATOR:Starts').toLowerCase()}
        </div>
      </div>
    </div>
  )
}

export default RelationItem
